import { ExhibitionListPage } from './../pages/exhibition-list/exhibition-list';
import { LangPipe } from './../lang.pip';
import { NgModule, ErrorHandler , NO_ERRORS_SCHEMA} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import{HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicModule, IonicErrorHandler, NavController } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { MuzeumPage } from '../pages/muzeum/muzeum';
import { WelcomePage } from '../pages/welcome/welcome';
import { ExhibitionPage } from '../pages/exhibition/exhibition';
import { SpotPage } from '../pages/spot/spot';
import { SpotsListPage } from '../pages/spots-list/spots-list';
import { MenuTabComponent } from "../components/menu-tab/menu-tab";

import { AngularFireModule } from 'angularfire2';
import { EscapeHtmlPipe } from './keep-html.pipe';

import { TopMenuComponent } from "../components/top-menu/top-menu";
//import {ComponentsModule} from '../components/components.module';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DataProvider } from '../providers/data/data';
import { IonicAudioModule, AudioProvider, WebAudioProvider, defaultAudioProviderFactory } from 'ionic-audio';
import { NguCarouselModule } from '@ngu/carousel';

//import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';


var DEBUG = false;
// ENABLE/DISABLE Console Logs
if(!DEBUG){ 
  window.console.log = function() {}
}

const firebaseConfig = {
  apiKey: "AIzaSyBQ1alWaQbjlxLxLTzz8Sjrpt5Cfo_R-Ek",
  authDomain: "muses-7746f.firebaseapp.com",
  databaseURL: "https://muses-7746f.firebaseio.com",
  projectId: "muses-7746f",
  storageBucket: "muses-7746f.appspot.com",
  messagingSenderId: "938162592997",
  appId: "1:938162592997:web:3549385c5a14dd4a2ec80c"
};



 
@NgModule({
  declarations: [
    MyApp,
    HomePage,
    MuzeumPage,
    LangPipe,
    SpotsListPage,
    ExhibitionListPage,
    WelcomePage,
    ExhibitionPage,
    TopMenuComponent,
    EscapeHtmlPipe,
    MenuTabComponent,
    SpotPage,
  ],
  imports: [
    HttpModule,
    HttpClientModule,
    BrowserModule,
    NguCarouselModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule,
   IonicAudioModule.forRoot(defaultAudioProviderFactory),
    IonicModule.forRoot(MyApp, {
      preloadModules: true
    }, {
      links: [
     
        { component: HomePage, name: 'Home', segment: 'home/:muzeum' },
        { component: WelcomePage, name: 'Welcome', segment: '' },
        { component: MuzeumPage, name: 'muzeum', segment: 'muzeum/:muzeum'},
        { component: ExhibitionPage, name: 'exhibition', segment: 'exhibition/:muzeum'},
        { component: SpotPage, name: 'spot', segment: 'spot/:muzeum', defaultHistory: [MuzeumPage]},
        { component: SpotsListPage, name: 'spotList', segment: 'spotList/:muzeum', defaultHistory: [HomePage]},
        { component: ExhibitionListPage, name: 'exhibitionlist', segment: 'exhibitionlist/:muzeum'},
      ]
   })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    MuzeumPage,
    WelcomePage,
    ExhibitionPage,
    ExhibitionListPage,
    TopMenuComponent,
    MenuTabComponent,
    SpotPage,
    SpotsListPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    DataProvider,
  ]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts